import React from "react";
import {
  createInstitute,
  updateInstitute,
  getInstitute,
  removeHttpAndHttpsFromWebsite,
} from "../services/instituteService";
import { getCountries, getProvinces } from "../services/regionService";
import { getTypes } from "./../services/typeService";
import Form from "./common/form";
import firebase from "../services/firebaseconn";
import Joi from "joi-browser";
import { Switch } from "antd";
import { getUser } from "../services/userService";

const NAME = "Nome";
const ABBREV = "Abreviação";
const TYPE = "Tipo";
const COUNTRY = "País";
const PROVINCE = "Província";
const TOWN = "Município";
const STREET_ADDRESS = "Bairro e Rua";
const PHONE_NUMBERS = "Números de telefone";
const EMAILS = "Endereços de email";
const WEBSITE = "Website";
const DESCRIPTION = "Descrição";
// const FIELDS = "Fields";
const EDIT = "Editar";
const SAVE = "Salvar";

class InstituteForm extends Form {
  state = {
    edit: true,
    currentUser: null,
    // id: "new",
    data: {
      name: "",
      abbrev: "",
      type: "",
      country: "",
      province: "",
      town: "",
      streetAddress: "",
      phoneNumbers: [],
      emails: [],
      // photoUris: [], // TODO: consider adding university photos in the future
      website: "",
      description: "",
    },
    errors: {},
    unsubscribeUser: undefined,
  };

  schema = {
    name: Joi.string().required().label(NAME),
    abbrev: Joi.string().allow(null, "").label(ABBREV),
    type: Joi.string().required().label(TYPE),
    country: Joi.string().required().label(COUNTRY),
    province: Joi.string().required().label(PROVINCE),
    town: Joi.string().required().label(TOWN),
    streetAddress: Joi.string().required().label(STREET_ADDRESS),
    phoneNumbers: Joi.array()
      .items(Joi.string())
      .required()
      .unique()
      .label(PHONE_NUMBERS),
    emails: Joi.array()
      .items(Joi.string().email())
      .required()
      .unique()
      .label(EMAILS),
    website: Joi.string().allow(null, "").label(WEBSITE),
    description: Joi.string().allow(null, "").label(DESCRIPTION),
  };

  async componentDidMount() {
    const unsubscribeUser = firebase.auth().onAuthStateChanged(async (user) => {
      if (user && user.email) {
        try {
          const currentUser = await getUser(user.email);

          if (!currentUser) return (window.location = "/logout");
          if (currentUser.admin) {
            this.populateInstitute();
            this.setState({ currentUser });
          } else return (window.location = "/logout");
        } catch (err) {
          console.log(err);
          window.location = "/logout";
        }
      } else {
        return (window.location = "/login");
      }
    });
    this.setState({ unsubscribeUser });
  }
  componentWillUnmount() {
    this.state.unsubscribeUser();
  }

  async populateInstitute() {
    try {
      const id = this.props.match.params.id;

      if (id === "new") return;

      const institute = await getInstitute(id);

      const { id: _id, reviewAvgs, ...rest } = institute;
      this.setState({
        edit: false,
        data: rest,
      });
    } catch (err) {
      if (err.response && err.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  doSubmit = async () => {
    this.setState({ edit: false });
    const id = this.props.match.params.id;
    let data = { ...this.state.data };
    const currentUser = { ...this.state.currentUser };
    data = removeHttpAndHttpsFromWebsite(data);

    try {
      if (id === "new") {
        const res = await createInstitute(data, currentUser);
        this.setState({ data });
        this.props.history.replace(`/institutes/form/${res.id}`);
      } else {
        await updateInstitute(id, data, currentUser);
        this.setState({ data });
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  render() {
    const edit = this.state.edit;
    const id = this.props.match.params.id;

    return (
      <div className="margin-footer">
        <h3> Formulário da instituição</h3>
        {id !== "new" ? (
          <div>
            <label htmlFor="edit">{EDIT}</label>
            <Switch
              name="edit"
              checked={edit}
              onChange={(checked, event) => {
                const newState = { ...this.state };
                newState.data = { ...this.state.data };
                newState.edit = checked;

                this.setState(newState);
              }}
            />
          </div>
        ) : null}

        <form onSubmit={this.handleSubmit}>
          {this.renderInput("name", NAME, !edit)}
          {this.renderInput("abbrev", ABBREV, !edit)}
          {this.renderSelect("type", TYPE, getTypes(), !edit)}
          {this.renderSelect("country", COUNTRY, getCountries(), !edit)}
          {this.renderSelect("province", PROVINCE, getProvinces(), !edit)}
          {/* TODO: convert town and street to select component */}
          {this.renderInput("town", TOWN, !edit)}
          {this.renderInput("streetAddress", STREET_ADDRESS, !edit)}

          {this.renderTagsInput("phoneNumbers", PHONE_NUMBERS, !edit)}
          {this.renderTagsInput("emails", EMAILS, !edit)}

          {this.renderInput("website", WEBSITE, !edit)}

          {this.renderTextArea("description", DESCRIPTION, !edit)}

          {this.renderButton(SAVE, !edit)}
        </form>
      </div>
    );
  }
}

export default InstituteForm;
